(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lss-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lss-personalisation')) {
  customElements.define('lss-personalisation', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.fields = this.querySelector('[data-fields]');
      this.inputs = this.querySelectorAll('[name^="properties["]');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.variantInput = this.form.querySelector('[name="id"]');
      this.previewChoice = this.querySelector('[data-preview-choice]');
      this.onChange = () => this.update();
      this.variantInput.addEventListener('change', this.onChange);
      this.previewChoice?.addEventListener('change', this.onChange);
      this.onSubmit = (event) => {
        if (!this.fields.hidden && (!this.form.reportValidity() || this.previewChoice)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.update();
    }
    update() {
      const variant = this.variants.find(item => String(item.id) === this.variantInput.value);
      const personalised = this.previewChoice
        ? this.previewChoice.value === 'personalised'
        : variant?.options.some(value => value === 'Personalised (+£7)');
      this.fields.hidden = !personalised;
      this.inputs.forEach(input => {
        input.disabled = !personalised || Boolean(this.previewChoice);
        input.required = personalised && !this.previewChoice;
      });
      if (this.previewChoice && personalised) this.inputs.forEach(input => input.disabled = false);
    }
    disconnectedCallback() {
      this.variantInput?.removeEventListener('change', this.onChange);
      this.previewChoice?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
